import { NgModule } from "@angular/core"
import { RouterModule } from "@angular/router"
import { BlogCreateComponent } from "@component/blog/blog-create/blog-create.component"
import { BlogDetailComponent } from "@component/blog/blog-detail/blog-detail.component"
import { BlogDisplayComponent } from "@component/blog/blog-display/blog-display.component"
import { BlogRelatedItemsComponent } from "@component/blog/blog-related-items/blog-related-items.component"
import { BlogComponent } from "@component/blog/blog/blog.component"
import { CommentComponent } from "@component/comments/comment/comment.component"
import { CommentsComponent } from "@component/comments/comments.component"
import { BlogCardComponentModule } from "@component/generic/cards/blog-card/blog-card.component"
import { PaginationComponentModule } from "@component/pagination/pagination.component"
import { EntityModule } from "./entity.module"
import { SharedModule } from "./shared.module"

@NgModule({
  declarations: [
    BlogComponent,
    BlogCreateComponent,
    BlogDetailComponent,
    BlogRelatedItemsComponent,
    BlogDisplayComponent,
    CommentsComponent,
    CommentComponent,
  ],
  imports: [
    SharedModule,

    RouterModule.forChild([
      {
        path: "",
        data: {
          title: 'Zimmerer-Blog'
        },
        component: BlogComponent
      },
      {
        path: "create",
        data: {
          title: 'Blog-Beitrag erstellen'
        },
        component: BlogCreateComponent
      },
      {
        path: "edit/:id",
        data: {
          title: 'Blogpost bearbeiten'
        },
        component: BlogCreateComponent
      },

      /* The :name is pretty irrelevant when using stateservice.goto it's only necessary so that the slug later is written when the state is loaded for seo */
      {
        path: "detail/:id/:name",
        component: BlogDetailComponent
      },
    ]),

    EntityModule,
    PaginationComponentModule,
    BlogCardComponentModule,
  ],
  exports: [
    SharedModule,
    BlogComponent,
    BlogCreateComponent,
    BlogDetailComponent,
    BlogRelatedItemsComponent,
    BlogDisplayComponent,
    CommentsComponent,
    CommentComponent,

    PaginationComponentModule,
    BlogCardComponentModule,
  ]
})
export class BlogModule { }
